import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    // constructor(private spinner: NgxSpinnerService) {}
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        // this.spinner.show();
        const currentUser = JSON.parse(localStorage.getItem('LoggedUser'));
        if (currentUser && currentUser.token) {
            request = request.clone({
                setHeaders: {
                    // origin : '*',
                    Authorization:`Bearer ${currentUser.token}`
                 },
            });
        }

        return next.handle(request).pipe(
            finalize(() => {
                // debugger;
                // this.spinner.hide();
            })
          );
    }
}
